import { FlattenedPlanData } from "../../hooks/useWellnessPlans";
import { actionTypes } from "./wellness-purchase-data.actions";

export interface IWellnessPurchaseState {
  wellnessPurchaseData: FlattenedPlanData | null;
}

const initialState: IWellnessPurchaseState = {
  wellnessPurchaseData: null,
};

export const wellnessPurchaseReducer = (
  state: IWellnessPurchaseState = initialState,
  action: { type: string, payload: any },
): IWellnessPurchaseState => {
  switch (action.type) {
  case actionTypes.SET_WELLNESS_PURCHASE_DATA:
    return {
      ...state,
      wellnessPurchaseData: action.payload,
    };
  default:
    return state;
  }
};
